export default __webpack_public_path__ + "static/media/890.51588fa0.png";